<script setup lang="ts">
  import { BaseButton } from '@qic/ui-components'
  import {
    BASE_CARD_TEST_ID,
    BASE_CARD_HEADING_TEST_ID,
    BASE_CARD_BUTTON_TEST_ID,
    BUTTON_CLICK_EVENT_NAME,
  } from './FlowCard.constants'
  interface Props {
    title?: string
    withButton?: boolean
    buttonText?: string
  }

  interface Emits {
    (e: typeof BUTTON_CLICK_EVENT_NAME): void
  }

  withDefaults(defineProps<Props>(), {
    withButton: true,
    buttonText: 'quote_proceed',
    title: '',
  })

  const emit = defineEmits<Emits>()

  const handleButtonClick = () => {
    emit(BUTTON_CLICK_EVENT_NAME)
  }
</script>

<template>
  <div class="base-card" :data-testid="BASE_CARD_TEST_ID">
    <slot name="header"></slot>
    <h1 v-if="title" class="base-card__title" :data-testid="BASE_CARD_HEADING_TEST_ID">
      {{ title }}
    </h1>
    <slot />
    <slot name="button">
      <BaseButton
        v-if="withButton"
        class="base-card__button"
        :data-testid="BASE_CARD_BUTTON_TEST_ID"
        @click="handleButtonClick"
      >
        {{ $t(buttonText) }}
      </BaseButton>
    </slot>
    <slot name="after" />
  </div>
</template>

<style lang="scss" scoped>
  @import './FlowCard';
</style>
